import {companyName} from '../../field-templates/company-name/companyName';
import {buildField} from '../../field-templates/fieldBuilder';

export default {
    groups: [
        {
            styleClasses: "row",
            fields: [buildField(companyName)],
        },
    ]
}
